<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="107.165"
    height="119.071"
    viewBox="0 0 107.165 119.071"
  >
    <path
      id="Контур_3575"
      data-name="Контур 3575"
      d="M146.143,417.769s2.258.377,4.437.617,5.685.431,5.685.431-1.891,6.821-.793,8.378c2.537,3.6,16.406,12.486,19.586,16.053a39.158,39.158,0,0,0,5.207,4.51c1.4,1.19,5.933,1.327,7.125,2.517.8.86,1.771,3.365,1.282,3.817-.334.309-7.2.46-8.407.243a5.872,5.872,0,0,1-2.879-1.259,1.965,1.965,0,0,1-2.328.3c-2.385-1.185-2.029-3.631-3.421-5.615-.8-.792-12.453-8.437-19.963-12.663-6.444-3.627-6.157-3.574-6.457-6.386-.2-1.847.926-10.938.926-10.938Zm32.676-78.121c-2.221-.726-3.056-3.386-6.229-3.032a7.923,7.923,0,0,0-6.144,3.914,15.847,15.847,0,0,0-.314,12.566c2.442,6.088,5.492,9.806,7.065,16.642.821,3.569-.456,8.347-4.23,10.466s-10.423-6.732-28.179-6.293-25.728,9.83-31.788,13.066a26.417,26.417,0,0,0-20.173,1.869A13.911,13.911,0,0,0,81.638,401.6c0,4.575,1.459,8.408,4.025,7.447,1.592-.321,2.064-4.458,3.836-4.758,1.307-.221-.136,3.417,1.339,3.735s6.634-4.087,8.031-2.85-1.074,6.074,0,6.973,6.133-.9,8.556-1.58c2.824-.79,3.892-1.263,4.663-.375-1.63,2.5-5.65,3.473-6.68,6.288s-4.034,24.43-5.69,26.415c-1.517,1.826-6.678,2.73-4.889,6.431-5.121,3.687-5.127,4.156-3.365,6.179.3.436,2.815-.172,4.06-.647,2.7-1.029,10.669-6.039,11.322-7.306.6-1.142.454-3.706.71-4.993.626-3.129,4.041-17.373,4.675-18.742,1.19-2.535,10.87-7.983,13.961-8.772,3.57-.907,10.406-1.027,19.144,0,6.314.743,12.488,1.6,19.639-.689,5.31-1.7,9.375-5.571,9.375-13.613,0-4.925-.361-5.311-.422-5.333h0c.034-.013.153-.108.419-.662,1.2-2.514,3-4.383,4.7-6.583,5.381-7.53,5.42-18.321,1.206-24.81s-5.287-8.118-5.482-12.677c-.164-3.585,1.743-5.615,4.768-5.292,1.29.138,6.985-1.189,6.615-2.876S181.039,340.373,178.819,339.649Z"
      transform="translate(-81.638 -336.584)"
      fill="#1ee984"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconDeliveryclub',
  }
</script>
